import Controller from '../abstracts/Controller';
import 'scss-templates/t-pdp.scss';

export default class PdpController extends Controller {
  static get COMPONENTS() {
    return [
      'SizeSelectorComponent',
      'PdpMainComponent',
      'PdpImagesComponent',
      'PdpSwatchesRadioGroup',
      'SkuInfoAccordionComponent',
      'CompleteLookComponent',
      'AddToCartComponent',
      'NotifyMeComponent',
      'WishlistComponent',
      'RecommendationEngineComponent',
      'GoogleRecommendationEngineComponent',
      'EditorialCoverInfiniteComponent',
      'JournalComponent',
      'InspiredComponent',
      'TabsComponent'
    ];
  }
}
